export class VerifypatientModule {
  LAST_NAME: any;
  FIRST_NAME: any;
  DOB: any;
  PRACTICE_CODE: any;
  APPOINTMENT_ID:any;
}
export class madisonVerification{
  firstName: any;
  lastName: any;
  practiceCode : any;
  dob : any;
}
export class UpdatemadisonPatientRecord{
  patient_Account : any;
  practice_Code : any; 
    last_Name : any;
    first_Name : any;
    date_Of_Birth : any;
    gender : any;
    marital_Status : any;
    address : any;
    city : any;
    state : any;
    zip : any;
    phoneNo : any;
    email_Address : any;
    occupationEmployerInfo : any;
}
export class ConsentForm{
   patientAccount : any;
   practiceCode : any ;
   isConsent : any ;
}

export class insurenacecard{
  PatientAccount  : any;
  PracticeCode : any ;
  InsuranceType : any ;
 // InsuranceCard = Array();
}

export class madisonPatientRecord{
  address: any;
  cell_phone: any;
  city : any;
  date_Of_Birth : any;
  email_Address : any;
  first_Name : any;
  gender : any;
  last_Name : any;
  marital_Status : any;
  patient_Account : any;
  practice_Code : any;
  state : any;
  zip : any;
}
export class PatientPersonalInfo {
  ADDRESS: any ="";
  APPOINTMENT_ID: any="";
  CELL_PHONE: any="";
  CELL_PHONE_TYPE: any="";
  CITY: any="";
  DOB: any="";
  EMAIL_ADDRESS: any="";
  ETHNICITIES: any="";
  FIRSTNAME: any="";
  GENDER: any="";
  HOME_PHONE: any="";
  LANGUAGES: any="";
  LASTNAME: any="";
  PATIENT_ACCOUNT: any="";
  PHARMACY2_ID: any="";
  PHARMACY2_NAME: any="";
  PHARMACY_ID: any="";
  PHARMACY_NAME: any="";
  RACE: any="";
  REASON_ID: any="";
  REASON_NAME: any="";
  STATE: any="";
  ZIP: any="";
  PRACTICE_CODE: any="";
  isShowpicture: any="";
  isEditProfilePic: any="";
  PracticeName: any="";
  BUSINESS_PHONE: any="";
  PICTURE_ADDRESS: any="";
  PROVIDER_CODE: any="";
  CHECK_NOCELLPHONE: any=false;
  CHECK_NOEMAIL: any=false;
}
export class Patient_PersonalInfo {
  ADDRESS: any ="";
  APPOINTMENT_ID: any="";
  CELL_PHONE: any="";
  CELL_PHONE_TYPE: any="";
  CITY: any="";
  DOB: any="";
  EMAIL_ADDRESS: any="";
  ETHNICITIES: any="";
  FIRSTNAME: any="";
  GENDER: any="";
  HOME_PHONE: any="";
  LANGUAGES: any="";
  LASTNAME: any="";
  PATIENT_ACCOUNT: any="";
  PHARMACY2_ID: any="";
  PHARMACY2_NAME: any="";
  PHARMACY_ID: any="";
  PHARMACY_NAME: any="";
  RACE: any="";
  REASON_ID: any="";
  REASON_NAME: any="";
  STATE: any="";
  ZIP: any="";
  PRACTICE_CODE: any="";
  isShowpicture: any="";
  isEditProfilePic: any="";
  PracticeName: any="";
  BUSINESS_PHONE: any="";
  PICTURE_ADDRESS: any="";
  PROVIDER_CODE: any="";
  CHECK_NOCELLPHONE: any=false;
  CHECK_NOEMAIL: any=false;
}
export class getPatientDataByURl {
  status: any;
  message: any;
  visitDate: any;
  timE_FROM: any;
  visitReason: any;
  dateOfBirth: any;
  emailAddress: any;
  cellPhone: any;
  firstName: any;
  lastName: any;
  practiceCode: any;
  todaY_AMMOUNT: any;
  previouS_AMMOUNT: any;
  providerLastName: any;
  providerFirstName: any;
  providerCode: any;
  practiceName: any;
  patientAccount: any;
  appointment_id: any;
  practicePhone: any;
  picture_Address: any
  languages: any
  practiceAddress: any;
  PracticeCity: any;
  praticeZip: any;
  practiceState: any;
  reason_Id:any
  reasonName:any
  appointmentStatusId:any
  appointmentDuration:any
  appointment_End_DateTime: any
  isBreezePaymentEnabled:any
  isPayLaterEnabled: any;
  appointmentAddress: any;
  appointmentState: any;
  appointmentCity: any;
  appointmentZip: any;
  appointmentType: any;
  appointmentLocation: any;
  userRoleName: any;
  providerTitle: any;
} 
export class auth
{
  USER_NAME: any;
  PWD: any;
}
export class PHIInfo{
  patienT_ACCOUNT : any;
  practicE_CODE : any;
 // contact : any
}
export class MadisonPHIdetails
{
  patienT_ACCOUNT :  any;
  practicE_CODE :  any;
  discloseD_TO : any;
  disclosurE_TYPE : any;
  disclosurE_DESCRIPTION : any;
  iS_DELETED : any;
  disclosurE_ID : any;
}
export class getMadisonPHIdetails
{
  discloseD_TO : any;
  disclosurE_DESCRIPTION : any
  disclosurE_TYPE : any ;
  patienT_ACCOUNT : any ;
  patienT_DISCLOSURE_ID : any ;
  practicE_CODE : any;
}
export class PatientfirstInakeData{

  Ref_person: any = '' ;
  visit_reason : any = '';
  Long_going : any  = '';

}
// export class PatientRefData_two{
//   Is_Patinjured : any =;
//   work_comp : any = '' ;
//   injury : any = '' ;
//   Seen_pro : any ='' ;
//   pro_name : any = '' ;
//   x_ray : any= '' ;
//   facility_name : any ='';
//   is_phy : any='' ;
//   phy_name : any='' ;
//   last_phy : any='' ;
//   last_blood : any='' ;
//   pt_script : any='' ;
//   ref_doc : any='' ;
//   rx_date : any='' ;
// }
export class patientRefData{

  patientAccount: any ;
  practiceCode : any;

  refPerson : any ="";
  visitReason : any ="";
  duration : any  ="";

  isPatientInjured :any ="Yes";
  workerComp :any = "";
  injuryDesccription : any = "";

  lastProvider : any = "" ;
  providerName : any = "";

  lastProcedure : any = "";
  facilityName : any = "";

  isPrimaryCarePhysician : any = "";
  lastPhysicianName : any = "";
  
  physicianName : any = ""

  

  lastPhysicalDate : any = "";
  lastBloodWorkDate : any = "";
  ptScript : any = "";
  referringDoctor : any ="";
  rxDate : any = "";
}
export class SendinjData{
  patientAccount : any ;
  practiceCode : any ; 
  description : any ;
  additionalDetail : any; 
}
